import type { ModalProps, StyleSystemProps } from '@withjoy/joykit';
import { Box, CloseButton, styled } from '@withjoy/joykit';

export const StyledBody = styled(Box)`
  display: flex;
  height: 100%;
  z-index: 1;
`;

export const StyledHeader = styled(Box)`
  background-color: transparent;
  display: flex;
  padding: 12px 16px;
  height: 56px;
  align-self: stretch;
  z-index: 1;
`;

export const StyledFooter = styled(Box)`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px;
  height: 80px;
  align-self: stretch;
  z-index: 1;
`;

export const StyledCloseButton = styled(CloseButton)`
  position: static;
  background: transparent;
  margin-left: auto;
  color: inherit;
  &:hover {
    color: inherit;
  }
`;

export const backButtonStyles: StyleSystemProps = {
  backgroundColor: 'transparent',
  fontWeight: 400,
  fontSize: '16px',
  color: 'inherit',
  _hover: {
    color: 'inherit',
  },
};

export const StyledDialogToastWrapper = styled.div`
  > div {
    top: 80px;
    width: 100%;
    margin: 0;
    border-radius: 0;
    z-index: 100;
  }
`;

export const buildDialogOverrides = (backgroundColor?: string, color?: string): NonNullable<ModalProps['overrides']> => ({
  Root: {
    props: {
      backgroundColor: 'rgb(0, 0, 0, 0.4)',
      overflow: 'auto',
    },
  },
  Content: {
    props: {
      borderRadius: [0, '32px'],
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: ['0 0 120px', '0'],
      margin: ['inherit', 'auto'],
      overflow: 'hidden',
      zIndex: 1,
      position: 'relative',
      backgroundColor: backgroundColor || 'white',
      color: color || 'inherit',
      transition: 'background-color 0.3s ease, color 0.3s ease',
    },
  },
});
